import { Component, Input, OnInit } from '@angular/core';
import { RegistrationService } from '../../services/registration.service';
import { combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommunityService } from '@common/services/community.service';
import { Registration } from '../../model/registration';
import { DecimalPipe } from '@angular/common';
import { ContentService } from '../../../../_common/services/content.service';

@Component({
    selector: 'app-counter',
    templateUrl: './counter.component.html',
    styleUrls: ['./counter.component.scss'],
    standalone: false
})
export class CounterComponent implements OnInit {
    @Input()
    variant: string;

    @Input()
    registration: Registration;

    public cmsParams: any;
    public stage: string;

    public get cmsKey(): string {
        return 'counter-' + this.variant + '-' + this.stage;
    }

    constructor(
        public communityService: CommunityService,
        public registrationService: RegistrationService,
        public contentService: ContentService,
        private decimalPipe: DecimalPipe,
    ) {}

    ngOnInit() {
        let auctionId: string = null;
        if (this.registration && this.registration.auction) {
            auctionId = this.registration.auction.id;
        }
        combineLatest([
            this.communityService.preventInterestedIndividualsSubscriptions$,
            this.communityService.currentAuctionOpenForNewRegistrations$,
            this.communityService.currentAuctionOpenForDecisions$,
        ])
            .pipe(
                map(
                    ([
                        preventInterestedIndividualsSubscriptions,
                        openForNewRegistrations,
                        openForDecisions,
                    ]) => {
                        return {
                            preventInterestedIndividualsSubscriptions:
                                preventInterestedIndividualsSubscriptions,
                            openForNewRegistrations: openForNewRegistrations,
                            openForDecisions: openForDecisions,
                        };
                    },
                ),
            )
            .subscribe((result) => {
                if (result.openForDecisions) {
                    this.stage = 'acceptation';
                } else if (result.openForNewRegistrations) {
                    this.stage = 'registration';
                } else if (result.preventInterestedIndividualsSubscriptions) {
                    this.stage = 'closed';
                } else {
                    this.stage = 'pre-registration';
                }
            });

        this.communityService.community$.subscribe((community) => {
            if (
                auctionId === null &&
                community.targetAuction &&
                community.targetAuction.id
            ) {
                auctionId = community.targetAuction.id;
            }
            combineLatest([
                this.registrationService.count(community.id),
                auctionId
                    ? this.registrationService.countSubscriptions(auctionId)
                    : of(0),
                auctionId
                    ? this.registrationService.countAcceptants(auctionId)
                    : of(0),
            ])
                .pipe(
                    map(
                        ([
                            participantCount,
                            subscriptionCount,
                            acceptantsCount,
                        ]) => [
                            {
                                participantCount:
                                    this.decimalPipe.transform(
                                        participantCount,
                                    ),
                                subscriptionCount:
                                    this.decimalPipe.transform(
                                        subscriptionCount,
                                    ),
                                acceptantsCount:
                                    this.decimalPipe.transform(acceptantsCount),
                            },
                        ],
                    ),
                )
                .subscribe((result) => (this.cmsParams = result));
        });
    }
}
